import { useCrudActions } from '@/common/view/useCrudActions';
import { facebookService } from '@/services/facebook';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useFacebook() {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        fbAppId: null,
        name: null,
        secret: null,
        accessToken: null,
        hasBusiness: false
    });

    const validations = {
        fbAppId: { required },
        name: { required },
        secret: { required },
        accessToken: { required },
        hasBusiness: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: facebookService().get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            model.fbAppId = data.fbAppId;
            model.name = data.name;
            model.secret = data.secret;
            model.accessToken = data.accessToken;
            model.hasBusiness = data.hasBusiness;
        },
        onError: () => {
            model.isNew = true;
            model.fbAppId = null;
            model.name = null;
            model.secret = null;
            model.accessToken = null;
            model.hasBusiness = false;
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                facebookService().update(model.fbAppId, model.name, model.secret, model.accessToken, model.hasBusiness),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: facebookService().remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
